import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer = ({ darkMode }) => {
    const currentYear = new Date().getFullYear();

    const quotes = [
        { text: "Hospitality is present when something happens for you. It is absent when something happens to you.", author: "Danny Meyer" },
        { text: "People will forget what you said, people will forget what you did, but people will never forget how you made them feel.", author: "Maya Angelou" },
        { text: "Service is a monologue; hospitality is a dialogue.", author: "Danny Meyer" },
        { text: "True hospitality is not just meeting expectations; it is anticipating desires before they are spoken.", author: "Horst Schulze" },
        { text: "It has been, and continues to be, our responsibility to fill the earth with the light and warmth of hospitality.", author: "Conrad Hilton" },
        { text: "Hospitality is about making people feel that they belong.", author: "Bill Marriott" },
        { text: "Do what you do so well that they will want to see it again and bring their friends.", author: "Walt Disney" },
        { text: "The reason for our success comes down to one rule: treat every guest as you would wish to be treated.", author: "Isadore Sharp" },
        { text: "Hospitality is the feeling you give people while delivering a service.", author: "Will Guidara" },
        { text: "Take care of your team, and they will take care of your guests, and the guests will keep coming back.", author: "J. Willard Marriott" },
        { text: "True hospitality consists of giving the best of yourself to your guests.", author: "Chip Conley" },
        { text: "Get closer than ever to your guests. Anticipate what they need well before they realize it themselves.", author: "Steve Jobs" },
        { text: "Make every interaction count. In hospitality, the smallest details leave the longest impressions.", author: "Shep Hyken" },
        { text: "The key is to not just meet guest expectations, but to exceed them in unexpected and memorable ways.", author: "Richard Branson" },
        { text: "Never say no when a guest asks for something. Finding a way is the true art of hospitality.", author: "César Ritz" }
    ];

    const [currentQuote, setCurrentQuote] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentQuote((prev) => (prev + 1) % quotes.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [quotes.length]);

    return (
        <footer role="contentinfo" aria-label="Footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img
                        src={darkMode ? '/logo3.avif' : '/logo-1.avif'}
                        alt="Logo"
                        className="footer-logo-img"
                        style={{ height: '52px' }}
                    />
                    <p>Business Digitalization Agency</p>
                </div>
                <div className="quote-feedback">
                    <div className="quote-content" key={currentQuote}>
                        <p className="quote-text">&ldquo;{quotes[currentQuote].text}&rdquo;</p>
                        <p className="quote-author">— {quotes[currentQuote].author}</p>
                    </div>
                </div>
                <div className="social-links" role="navigation" aria-label="Social media links">
                    <a
                        href="https://www.instagram.com/elyspr.in?igsh=MTZ1ZzEyMHBpaDgxMQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram profile"
                    >
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a
                        href="https://www.linkedin.com/company/elyspr"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn profile"
                    >
                        <i className="fab fa-linkedin"></i>
                    </a>
                </div>
                <div className="footer-contact">
                    <a href="mailto:info@elyspr.com" className="footer-contact-item footer-email">info@elyspr.com</a>
                    <p className="footer-contact-item footer-phone">
                        <a href="tel:+918655810187">8655810187</a>
                        <span className="footer-phone-sep" aria-hidden="true"> / </span>
                        <a href="tel:+918655810188">8655810188</a>
                        <span className="footer-phone-sep" aria-hidden="true"> / </span>
                        <a href="tel:+918655810189">8655810189</a>
                    </p>
                </div>
            </div>
            <p className="copyright">&copy; {currentYear} All rights reserved.</p>
        </footer>
    );
};

export default Footer;
